export default class VoyageConstraintsCreateData {
    constructor(
        maxTurningAngle,
        maxWindServiceSpeed,
        maxWindCruiseSpeed,
        maxWaveServiceHeight,
        maxWaveCruiseHeight,
    ) {
        this.maxTurningAngle = maxTurningAngle;
        this.maxWindServiceSpeed = maxWindServiceSpeed;
        this.maxWindCruiseSpeed = maxWindCruiseSpeed;
        this.maxWaveServiceHeight = maxWaveServiceHeight;
        this.maxWaveCruiseHeight = maxWaveCruiseHeight;
    }
}